import { TFunction } from 'i18next'
import { ErrorCode, FileRejection } from 'react-dropzone'

import { IMPORTED_INVOICE_MAX_SIZE_MB } from '../constants/importedInvoicesUpload'

/**
 * STR-223 — turns a react-dropzone rejection into the reason line the imported
 * (shoebox) upload toasts quote.
 *
 * The DS rewrites `error.message` in place before our handlers run
 * (`translateRejectedFilesErrors`), but `error.code` survives, so the oversize case
 * can be recognised and given the design's own sentence instead of the DS default
 * ("The file is too large. Maximum size is: 10 MB").
 *
 * A single rejection can carry several errors. Size supersedes every other code
 * because it is the one the user can act on by picking a different file rather than
 * a different format.
 */
export function getImportedUploadRejectionMessage(fileRejection: FileRejection, t: TFunction): string {
  const isTooLarge = fileRejection.errors.some((error) => error.code === ErrorCode.FileTooLarge)

  if (isTooLarge) {
    return t('imported_invoices.upload.error.file_too_large', { maxSizeMb: IMPORTED_INVOICE_MAX_SIZE_MB })
  }

  return fileRejection.errors.map((error) => error.message).join(', ')
}
